export default {
  floatingTopMenu: {
    'openSettings': 'Ajustes',
    'showAbout': 'Mostrar información general',
    'about': 'Acerca de ORS',
    'openrouteserviceAPI': 'Openrouteservice API',
    'openrouteserviceForDisasters': 'Openrouteservice para desastres',
    'askOpenrouteservice': 'Ask openrouteservice',
    'settingsTooltip': 'Haga clic aquí si desea ajustar la configuración de la aplicación y ver otras opciones'
  }
}
